<div class="login_container" *ngIf="!authService.isLoggedIn()">
  <img src="assets/img/google_signin.png" (click)="clickLogin()" />
</div>
<div class="login_container" *ngIf="authService.isLoggedIn()">
  You are already logged in
</div>
